import { render, staticRenderFns } from "./FormTelField.vue?vue&type=template&id=624570da&"
import script from "./FormTelField.vue?vue&type=script&lang=ts&"
export * from "./FormTelField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports